import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import NavigationHeader from 'components/molecules/navigation-header';
import BaseTabs from 'components/atoms/base-tabs';
import ScrollToTopButton from 'components/atoms/scroll-to-top-button';
import MedicationSummary from 'components/organisms/admin-panel/medication-details/summary';
import MedicationPapForms from 'components/organisms/admin-panel/medication-details/papForms';
import { transformMedicationDetailTextField } from 'components/organisms/admin-panel/medication-details/utils';
import EditProvider from 'infrastructure/providers/edit-provider';
import {
  useAdminMedicationDetails,
  useAdminMedicationPapForms,
  useAdminMedicationsActions,
} from 'infrastructure/hooks/medications';
import { Routes } from 'router/routes';

import s from './styles.module.scss';

const AdminMedicationDetailsPage = () => {
  const { medicationGuid } = useParams();
  const { t } = useTranslation();
  const detailsQuery = useAdminMedicationDetails(medicationGuid);
  const [papFormsPage, setPapFormsPage] = useState(1);
  const [papFormsPageSize, setPapFormsPageSize] = useState(10);

  useEffect(() => {
    setPapFormsPage(1);
  }, [medicationGuid]);

  const papFormsQuery = useAdminMedicationPapForms(
    medicationGuid,
    papFormsPage,
    papFormsPageSize,
  );
  const actions = useAdminMedicationsActions();
  const [activeTab, setActiveTab] = useState('details');

  const handlePapFormsPageChange = (page: number, pageSize: number) => {
    setPapFormsPage(page);
    setPapFormsPageSize(pageSize);
  };

  const tabs = [
    {
      key: 'details',
      label: t('labels.details'),
    },
    {
      key: 'papForms',
      label: t('labels.papForms'),
    },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'details':
        return (
          <MedicationSummary
            medication={transformMedicationDetailTextField(
              detailsQuery.medication,
            )}
            isLoading={detailsQuery.isLoading}
          />
        );
      case 'papForms':
        return (
          <MedicationPapForms
            medicationGuid={medicationGuid}
            papForms={papFormsQuery.papForms}
            isLoading={papFormsQuery.isFetching}
            refetchPapForms={papFormsQuery.refetch}
            refetchMedication={detailsQuery.refetch}
            actions={actions}
            currentPage={papFormsPage}
            pageSize={papFormsPageSize}
            onPageChange={handlePapFormsPageChange}
          />
        );
      default:
        return null;
    }
  };

  return (
    <EditProvider>
      <div className={s.wrapper}>
        <NavigationHeader
          title={`Medication: ${detailsQuery?.medication?.name || ''}`}
          goBackPath={Routes.adminMedications}
        />
        <div>
          <BaseTabs
            tabs={tabs}
            activeKey={activeTab}
            onChange={(tab) => setActiveTab(tab.key)}
          />
          {renderTabContent()}
        </div>
        <ScrollToTopButton />
      </div>
    </EditProvider>
  );
};

export default AdminMedicationDetailsPage;
